import { z } from "zod";
import { IsoDateTimeSchema } from "./common";
import { BookIdSchema, VoiceIdSchema } from "./ids";
import { BookLanguageSchema, VoiceSourceSchema } from "./states";

/** ElevenLabs voice labels as the Casting table shows them (ACCENT, CHARACTER). */
export const VoiceLabelsSchema = z.strictObject({
  accent: z.string().nullable(),
  description: z.string().nullable(),
  age: z.string().nullable(),
  gender: z.string().nullable(),
  useCase: z.string().nullable(),
});
export type VoiceLabels = z.infer<typeof VoiceLabelsSchema>;

export const VoiceSchema = z.strictObject({
  id: VoiceIdSchema,
  elevenlabsVoiceId: z.string(),
  name: z.string(),
  language: BookLanguageSchema,
  source: VoiceSourceSchema,
  labels: VoiceLabelsSchema,
  previewUrl: z.url().nullable(),
  /** The Voice a Pronunciation Check uses for this language before Casting. */
  isDefaultForLanguage: z.boolean(),
  recommended: z.boolean().optional(),
  rate: z.number().positive().nullable().optional(),
  supportedLanguages: z.array(z.string()).optional(),
});
export type Voice = z.infer<typeof VoiceSchema>;

export const VoicesQuerySchema = z.strictObject({
  language: BookLanguageSchema.optional(),
});
export type VoicesQuery = z.infer<typeof VoicesQuerySchema>;

export const VoicesResponseSchema = z.strictObject({ voices: z.array(VoiceSchema) });
export type VoicesResponse = z.infer<typeof VoicesResponseSchema>;

export const CastingSchema = z.strictObject({
  bookId: BookIdSchema,
  narrator: VoiceSchema.nullable(),
  /** Locked once any Chapter has Chapter Audio (409 CASTING_LOCKED on PUT). */
  locked: z.boolean(),
  updatedAt: IsoDateTimeSchema.nullable(),
});
export type Casting = z.infer<typeof CastingSchema>;

/** PUT /books/:id/casting: 422 VOICE_LANGUAGE_MISMATCH when the Voice's language is not the Book's. */
export const CastingPutSchema = z.strictObject({
  voiceId: VoiceIdSchema,
});
export type CastingPut = z.infer<typeof CastingPutSchema>;
